// extracted by mini-css-extract-plugin
export default {"message_container":"ErrorBoundary_message_container__1sguZ","text":"ErrorBoundary_text__Q1Voy","btn":"ErrorBoundary_btn__ZpA2+"};